import { toLocalizedUrl } from 'tradera-utils/url';
import { isServer } from 'tradera-utils/nextjs';

export const toLocalizedRiotUrl = url => toLocalizedUrl(url, getLanguage());

let language;
export const getLanguage = () => {
    if (isServer) {
        return;
    }
    if (language === '' || language === null || language === undefined) {
        language = document.querySelector('html').getAttribute('lang');
    }

    return language;
};
